import actions from './actions';

const initState = {
    data: []
};

export default function ElectricityReducer(state = initState, action) {
    switch (action.type) {
        case actions.Electricity_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
